export default function (text) {
  this.sendEvent('dev.test', { text })
}
